import { render, staticRenderFns } from "./StudyLocationRegisterPage.vue?vue&type=template&id=26fb5bcb&scoped=true&"
import script from "./StudyLocationRegisterPage.vue?vue&type=script&lang=ts&"
export * from "./StudyLocationRegisterPage.vue?vue&type=script&lang=ts&"
import style0 from "./StudyLocationRegisterPage.vue?vue&type=style&index=0&id=26fb5bcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fb5bcb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTextField,VTooltip})
